import { Injectable, Injector } from '@angular/core';
import { DaoBaseService } from './dao-base.service';
import { UnidadeEntregaObjetivo } from '../models/unidade-entrega-objetivo.model';
import { PlanejamentoObjetivo } from '../models/planejamento-objetivo.model';

export type ObjetivosResult = {
  entregas?: any[];
  servidores?: any[];
  chd?: any[];
  pents?: any[];
}

@Injectable({
  providedIn: 'root'
})
export class UnidadeEntregaObjetivoDaoService extends DaoBaseService<UnidadeEntregaObjetivo> {

  constructor(protected injector: Injector) { 
    super("UnidadeEntregaObjetivo", injector);
    this.inputSearchConfig.searchFields = ["objetivo.nome"];
  }

  public contribuinteObjetivo(objetivo_id: string): Promise<ObjetivosResult> {
    return new Promise<ObjetivosResult>((resolve, reject) => {
      this.server.post('api/UnidadeEntregaObjetivo/contribuinteObjetivo', { objetivo: objetivo_id }).subscribe(response => {
        if(response.error){
          reject(response.error);
        } else {
          resolve(response?.dados || []);
        }  
      }, error => reject(error));
    });
  }

  public contribuinteProcesso(processo_id: string): Promise<ObjetivosResult> {
    return new Promise<ObjetivosResult>((resolve, reject) => {
      this.server.post('api/UnidadeEntregaProcesso/contribuinteProcesso', { processo: processo_id }).subscribe(response => {
        if(response.error){
          reject(response.error);
        } else {
          resolve(response?.dados || []);
        }  
      }, error => reject(error));
    });
  }

}

